import { API_METHOD, BASE_API_URL } from "@/constants";
import { fetcher } from "@/lib";
import {
  AddNewsArticleParams,
  AddNewsArticleResponse,
  NewsArticle,
  NewsArticleCategory,
  NewsArticleCategoryResponse,
  NewsArticleParams,
  NewsArticleResponse,
  NewsArticleTranslate,
  NewsArticleTranslateParams,
} from "@/types";

// News articles
export async function getNewsArticles({
  offset = 0,
  limit = 10,
  category_id,
  status,
  search,
}: NewsArticleParams): Promise<NewsArticleResponse> {
  return fetcher(
    `${BASE_API_URL}/articles?offset=${offset}&limit=${limit}&category_id=${category_id}&status=${status}&search=${search}`,
    { method: API_METHOD.GET }
  );
}

// Get news article categories
export async function getNewsArticleCategories(): Promise<NewsArticleCategory[]> {
  return fetcher(`${BASE_API_URL}/article-categories`, { method: API_METHOD.GET });
}

// News article detail
export async function getNewsArticleDetail({
  articleId,
}: {
  articleId: string;
}): Promise<NewsArticle> {
  return fetcher(`${BASE_API_URL}/articles/${articleId}`, { method: API_METHOD.GET });
}

// News article translate detail
export async function translateNewsArticle({
  articleId,
  targetLang,
}: {
  articleId: string;
  targetLang: string;
}): Promise<NewsArticleTranslate> {
  return fetcher(`${BASE_API_URL}/articles/translate/${articleId}`, {
    method: API_METHOD.POST,
    body: JSON.stringify({ target_lang: targetLang }),
  });
}

// Add news article
export async function addNewsArticle(
  params: AddNewsArticleParams
): Promise<AddNewsArticleResponse> {
  return fetcher(`${BASE_API_URL}/articles`, {
    method: API_METHOD.POST,
    body: JSON.stringify(params),
  });
}

// Update news article
export async function updateNewsArticle(
  articleId: string,
  params: AddNewsArticleParams
): Promise<AddNewsArticleResponse> {
  return fetcher(`${BASE_API_URL}/articles/${articleId}`, {
    method: API_METHOD.PUT,
    body: JSON.stringify(params),
  });
}

// Update news article translation
export async function updateNewsArticleTranslation(
  articleId: string,
  params: NewsArticleTranslateParams
): Promise<NewsArticleTranslate> {
  return fetcher(`${BASE_API_URL}/articles/translate/${articleId}`, {
    method: API_METHOD.PUT,
    body: JSON.stringify(params),
  });
}

// Update news article
export async function deleteNewsArticle(articleId: string): Promise<AddNewsArticleResponse> {
  return fetcher(`${BASE_API_URL}/articles/${articleId}`, {
    method: API_METHOD.DELETE,
  });
}

// Add news article category
export async function addNewsArticleCategory({
  id,
  name,
  description = "",
}: {
  id: string;
  name: string;
  description?: string;
}): Promise<NewsArticleCategoryResponse> {
  return fetcher(`${BASE_API_URL}/article-categories`, {
    method: API_METHOD.POST,
    body: JSON.stringify({ id, name, description }),
  });
}

// Update news article category
export async function updateNewsArticleCategory({
  categoryId,
  name,
  description = "",
}: {
  categoryId: string;
  name: string;
  description?: string;
}): Promise<NewsArticleCategoryResponse> {
  return fetcher(`${BASE_API_URL}/article-categories/${categoryId}`, {
    method: API_METHOD.PUT,
    body: JSON.stringify({ name, description }),
  });
}

// Delete news article category
export async function deleteNewsArticleCategory({
  categoryId,
}: {
  categoryId: string;
}): Promise<NewsArticleCategoryResponse> {
  return fetcher(`${BASE_API_URL}/article-categories/${categoryId}`, {
    method: API_METHOD.DELETE,
  });
}
